import React, { useState, useRef } from "react";
import * as pdfjsLib from "pdfjs-dist";
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export default function PDFToImage({ file }) {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const cancelRef = useRef(false);

  // Only convert when user clicks Convert
  React.useEffect(() => {
    if (!file) {
      setImages([]);
      setLoading(false);
    }
    // Don't auto-convert on file change
    // eslint-disable-next-line
  }, [file]);

  const handleConvert = async () => {
    if (!file) return;
    setLoading(true);
    setImages([]);
    cancelRef.current = false;
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    const imgs = [];
    for (let i = 1; i <= pdf.numPages; i++) {
      if (cancelRef.current) {
        setLoading(false);
        return;
      }
      const page = await pdf.getPage(i);
      const viewport = page.getViewport({ scale: 2 });
      const canvas = document.createElement("canvas");
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      const ctx = canvas.getContext("2d");
      await page.render({ canvasContext: ctx, viewport }).promise;
      imgs.push(canvas.toDataURL("image/png"));
    }
    setImages(imgs);
    setLoading(false);
  };

  const handleCancel = () => {
    cancelRef.current = true;
    setLoading(false);
  };

  const downloadAll = () => {
    images.forEach((img, idx) => {
      fetch(img)
        .then(res => res.blob())
        .then(blob => saveAs(blob, `page-${idx + 1}.png`));
    });
  };

  return (
    <div>
      {!file && (
        <div style={{ color: '#c00', fontSize: 17, margin: '24px 0', textAlign: 'center', fontWeight: 500 }}>
          No file selected. Please upload a PDF file to begin.
        </div>
      )}
      {file && !loading && images.length === 0 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button onClick={handleConvert} style={{ padding: '10px 24px', fontSize: 16, borderRadius: 8, background: '#007bff', color: '#fff', border: 'none', marginBottom: 16 }}>Convert</button>
          <button
            onClick={() => {
              if (typeof window !== 'undefined') {
                const input = document.getElementById('pdf-upload');
                if (input) input.value = null;
              }
              if (typeof window.setFile === 'function') {
                window.setFile(null);
              }
            }}
            style={{ color: '#c00', background: 'none', border: 'none', fontWeight: 'bold', fontSize: 18, cursor: 'pointer' }}
            title="Remove file"
          >×</button>
        </div>
      )}
      {loading && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span>Converting...</span>
          <button onClick={handleCancel} style={{ color: 'red' }}>Cancel</button>
        </div>
      )}
      {images.length > 0 && (
        <div>
          <button onClick={downloadAll}>Download All Images</button>
          <button
            onClick={() => {
              if (typeof window !== 'undefined') {
                const input = document.getElementById('pdf-upload');
                if (input) input.value = null;
              }
              if (typeof window.setFile === 'function') {
                window.setFile(null);
              }
            }}
            style={{ color: '#c00', background: 'none', border: 'none', fontWeight: 'bold', fontSize: 18, cursor: 'pointer', marginLeft: 8 }}
            title="Remove file"
          >×</button>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 16 }}>
            {images.map((img, i) => (
              <img key={i} src={img} alt={`Page ${i + 1}`} style={{ maxWidth: 200, border: "1px solid #ccc" }} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
